import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Inject } from '@angular/core';
import get from 'lodash-es/get';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'finder-list-block',
    templateUrl: './list-block.component.html',
    styleUrls: ['./list-block.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        FontIconComponent,
        SafeHtmlPipe,
    ]
})
export class ListBlockComponent implements OnInit, OnChanges {
    @Input() data: any;

    classes;
    iconStyles;

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.setStyling();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data.firstChange) {
            return;
        }

        this.setStyling();
    }

    private setStyling() {
        const sections = this.data.sections;
        const backgroundColor1 = get(sections, 'backgroundColor1');
        const backgroundColor2 = get(sections, 'backgroundColor2');
        const fontColor = get(sections, 'fontColor');

        // Update the css vars
        if (backgroundColor1 && backgroundColor2) {
            this.document.documentElement.style.setProperty('--list-block-bg-color-1', backgroundColor1);
            this.document.documentElement.style.setProperty('--list-block-bg-color-2', backgroundColor2);
        }

        if (fontColor) {
            this.document.documentElement.style.setProperty('--list-block-color', fontColor);
        }

        this.classes = {
            'one-column': !!get(sections, 'oneColumn', false),
            'color-links': !!get(sections, 'fontColor', false),
        };
        this.iconStyles = {
            color: get(sections, 'iconColor', 'auto'),
        };
    }
}
